import { Button, Dropdown, Image, message, Space, Tooltip } from "antd";
import { useState } from "react";
import { LangItem } from "../Detail";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
import { showErrorMessage } from "../../../helpers/errorHandler";
import { ListingProperties } from "../../../types/listing.type";
import useAuth from "../../../hooks/useAuth";
import axios from "axios";
import { generateQueryString } from "../../../helpers/generateQueryString";
import { httpRequest } from "../../../helpers/api";
import { BaseResponseProps } from "../../../types/config.type";
import { ListingMaskingHistoryProperties } from "../../../types/listingMaskingHistory.type";

interface IProps {
	listing: ListingProperties;
	fetchList: any;
	notif: any;
}
export default function DropdownDownloadPdf({ listing, fetchList, notif }: IProps) {
	const [isDownloadLoading, setIsDownloadLoading] = useState<boolean>(false);
	const { employeeId } = useAuth();
	const LANG_EN = (
		<LangItem>
			<Image
				src="/en-flag.png"
				alt="ENG logo"
				width={24}
				height={15}
				preview={false}
			/>
			<span>ENG</span>
		</LangItem>
	);
	const LANG_ID = (
		<LangItem>
			<Image
				src="/id-flag.png"
				alt="IND logo"
				width={24}
				height={15}
				preview={false}
			/>
			<span>ID</span>
		</LangItem>
	);

	const LANG_ITEMS = [
		{
			label: LANG_ID,
			key: "id",
		},
		{
			label: LANG_EN,
			key: "en",
		},
	];

	const doDownloadPDF = async (lang: string) => {
		if (!listing?.pdfOrientation) return message.error("Please wait until loading finished");
		setIsDownloadLoading(true);
		const query = {
			lang,
			listingCode: listing.listingCode,
			employeeId,
		};

		const dto = {
			employeeId,
			listingId: listing.listingId,
			type: "PDF",
		};
		await httpRequest.post<BaseResponseProps<ListingMaskingHistoryProperties>>("/listing-masking-histories", dto);

		axios({
			url: `${process.env.REACT_APP_PDF_URL}/pdf/listing/${listing.listingId}${generateQueryString(query)}`,
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			responseType: "blob",
		})
			.then((res: any) => {
				if (res && res.data) {
					const url = window.URL.createObjectURL(new Blob([res.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", `${listing.title}-${listing.listingCode}.pdf`);
					document.body.appendChild(link);
					link.click();
					link.parentNode?.removeChild(link);

					notif.success({
						message: undefined,
						description:
							"Your request for Masking PDF download has been successful! You can now check it on your device.",
						style: {
							backgroundColor: "#DFF4E0",
							border: "1px solid #55C95A",
						},
					});

					fetchList();
				}
			})

			.catch((error) => {
				showErrorMessage(error, true);
			})
			.finally(() => {
				setIsDownloadLoading(false);
			});
	};

	return (
		<>
			<Space>
				<Tooltip title="Download PDF">
					<Dropdown
						menu={{
							items: LANG_ITEMS,
							onClick: async ({ key }) => {
								await doDownloadPDF(key);
							},
						}}
					>
						<Button
							loading={isDownloadLoading}
							style={{
								padding: "6px 10px",
							}}
							type="primary"
							icon={<VerticalAlignBottomOutlined style={{ fontSize: 16 }} />}
						></Button>
					</Dropdown>
				</Tooltip>
			</Space>

			{/* <Modal
				title="Masking"
				footer={null}
				open={showPreview}
				destroyOnClose={true}
				onCancel={() => {
					setShowPreview(false);
				}}
			>
				<Row>
					<Col span={24}>
						<DetailItem
							label="Listing ID"
							value={listing.listingCode}
						/>
					</Col>
					<Col span={24}>
						<DetailItem
							label="Listing Title"
							value={listing.title}
						/>
					</Col>
					<Col span={24}>
						<DetailItem
							label="Listing Last Updated At"
							value={formatYearToTime(listing.updatedAt)}
						/>
					</Col>
					<Divider />

					<Col span={12}>
						<DetailItem
							label="Last Generated At"
							value={formatYearToTime(getPdfId?.updatedAt)}
						/>
						<Space>
							<Dropdown
								disabled={disabledPdfButton(getPdfEn) || disabledPdfButton(getPdfId)}
								menu={{
									items: LANG_ITEMS,
									onClick: async ({ key }) => {
										await handleDownloadPdf(key);
									},
								}}
							>
								<Button
									type="primary"
									loading={isDownloadLoading}
									icon={<VerticalAlignBottomOutlined style={{ fontSize: 16 }} />}
									style={{
										padding: "6px 10px",
									}}
								>
									({pdfListingMaskingCount}) <DownOutlined />
								</Button>
							</Dropdown>

							<Button
								disabled={isGenerating(getPdfEn) || isGenerating(getPdfId)}
								loading={isDownloadLoading}
								style={{
									padding: "6px 10px",
								}}
								type="primary"
								onClick={() => {
									confirmModal({
										title: "Regenerate Masking Listing PDF",
										subtitle: "Are you sure want to regenerate the PDF for this masking listing?",
										onOk: async () => {
											await doDownloadPDF("", listing);
										},
									});
								}}
							>
								{isGenerating(getPdfEn) || isGenerating(getPdfId) ? (
									"PDF being generated..."
								) : (
									<>Regenerate PDF</>
								)}
							</Button>
						</Space>
					</Col>

					{new Date(listing.updatedAt) > new Date(getPdfId?.updatedAt as Date) && (
						<Col span={24}>
							<Alert
								style={{
									marginTop: 12,
								}}
								className="warning-watermark"
								message="Regenerate pdf to get updated listing"
								type="warning"
								showIcon
								icon={<ExclamationCircleOutlined />}
							/>
						</Col>
					)}
				</Row>
			</Modal> */}
		</>
	);
}
